export default __webpack_public_path__ + "metadata-nudge-bg.png";